module.exports = __webpack_public_path__ + "media/assets/img/video/bold-a4a21e49ca5060876d6d80397aca6b75.svg";